import { useEffect } from "react";
import styles from "./MentionMe.module.css";

type MentionMeProps = {
  mentionMeUrl: string;
};

export function MentionMe({ mentionMeUrl }: MentionMeProps) {
  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.src = mentionMeUrl;

    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
  }, [mentionMeUrl]);

  return <div id="mmWrapper" className={styles.MentionMe} />;
}
